﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
//import dummy from '../../../../app/plugins';


import tpl_pictureSingleList from './tpl/pictureSingleList.html';
import View_PictureSingleListItem from './pictureSingleListItem';

export default Marionette.CollectionView.extend({
    tagName: 'div',
    className: '',
    attributes: function () {
        return {
            id: 'pictureSingleListItem'
        }
    },
    childViewContainer: '#pictureSingleListItem',
    childView: View_PictureSingleListItem,
    getTemplate: function () {
        return tpl_pictureSingleList();
    },
    ui: {
        'pictureSingleListItem': '#pictureSingleListItem'
    },

    initialize: function () {
        this.app = this.options.app;

    },
    buildChildView: function (child, ChildViewClass, childViewOptions) {
        var options = _.extend({ model: child }, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    },
    onAttach() {
        var self = this;

        
        $('#pictureSingleListA').find('#pictureSingleListItem').sortable({
            items: '.myDiv',
            //handle:'.myDiv',
            stop: function (event, ui) {
                var position = 0;
                $('#pictureSingleListItem .myDiv').each(function (index, item) {
                    var id = parseInt($(item).attr('data-id'));
                    if (id != undefined) {
                        var model = self.collection.where({ id: id })[0];
                        //model.attributes.Position = position;
                        model.set({ Position: position });
                        $(item).attr('data-position', position);
                        position++;
                    }
                });
            }
        });

        $('#pictureSingleListA').find('pictureSingleListItem_tr').each(function (index, item) {
            $(item).addClass('ui-state-default');
            $(item).addClass('ui-sortable-handle');
        });
    }
});
